module.exports = __webpack_public_path__ + "static/img/btn_shibai_nor.e5c00a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/IdentitAuthentication/images/btn_shibai_nor.png
// module id = 20Yu
// module chunks = 1